import DOMPurify from 'dompurify';

/** Escape text for safe insertion into HTML attribute/text contexts (print popups, etc.). */
export function escapeHtml(value: string): string {
	return String(value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

/**
 * Sanitize server-supplied HTML for trusted display (e.g. EULA).
 * Strict allowlist: formatting tags only — no scripts, event handlers, or iframes.
 */
export function sanitizeHtml(dirty: string): string {
	return DOMPurify.sanitize(dirty ?? '', {
		USE_PROFILES: { html: true },
		FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'link', 'meta'],
		FORBID_ATTR: ['style'],
		ALLOW_DATA_ATTR: false,
	});
}
